import CardMenu from "components/card/CardMenu";
import Card from "components/card";
import {DiApple} from "react-icons/di";
import {DiAndroid} from "react-icons/di";
import {DiWindows} from "react-icons/di";

import React, {useMemo, useState} from "react";
import {
    useGlobalFilter,
    usePagination,
    useSortBy,
    useTable,
} from "react-table";


import Progress from "components/progress";
import {useUserAuth} from "../../../../context/UserAuthContext";
import {AES, enc} from "crypto-js";
import {useNavigate} from "react-router-dom";
import axios from "axios";
import useAsyncEffect from "use-async-effect";
import CustomPagination from "../../../../components/CustomPagination/CustomPagination";
import {utils, writeFile} from "xlsx";
import SearchIcon from "../../../../components/icons/SearchIcon";
import {MdChevronLeft, MdChevronRight} from "react-icons/md";
import Alerts from "../../error";
import UsersOverView from "../components/ProductCatalogPage";
import {columnsDataUsersOverview} from "../../users/variables/columnsDataUsersOverview";
import DpIdOverView from "./DpIdOverview";
import {columnsDataDpIdOverview} from "./columnsDataDpIdOverview";

const DpConfigTable = () => {

    const CROMPTON_URL = process.env.REACT_APP_CROMPTON_SENZE_URL;
    const CROMPTON_ANALYTICS_URL = process.env.REACT_APP_CROMPTON_SENZE_ANALYTICS_URL;

    //const CROMPTON_URL = "https://iot.crompton.co.in:8443/PAPI/"
    //const CROMPTON_ANALYTICS_URL = "https://iot.crompton.co.in:8443/AAPI/"
    const secretKey = "cromptonssecretkey";

    let {Token, logOut, Username, accesscontrollevel} = useUserAuth();
    const decryptedValueuname = AES.decrypt(Username, secretKey).toString(enc.Utf8);
    const decryptedValue = AES.decrypt(Token, secretKey).toString(enc.Utf8);
    const navigate = useNavigate();
    const [userResult, setUserResult] = useState([]);
    const [pg, setpg] = useState(0);
    const [rpg, setrpg] = useState(10);
    let [total, setTotal] = useState(0)
    let [loading, setIsLoading] = useState(true)

    function handleChangePage(event, newpage) {
        setpg(newpage);
    }

    function handleChangeRowsPerPage(event) {
        setrpg(parseInt(event.target.value, 10));
        setpg(0);
    }

    const handleLogOut = async () => {
        try {
            await logOut();
            navigate("/");
        } catch (error) {
            ////console.log(error.message);
        }
    }

    function getAllUserDetails() {
        var url = CROMPTON_ANALYTICS_URL + "v1/device/dpIds"
        //console.log("Inside dpid api")
        axios({
            method: "GET", url: url, headers: {
                Authorization: decryptedValue,
            }

        }).then((res) => {

            //console.log(res)
            setUserResult(res.data)
            setIsLoading(false)

        }).catch((error) => {
            //console.log(error)
            setIsLoading(false)
            if (error.response.data.status === "401" || error.response.data.status === "403") {
                handleLogOut();
            }
        })

    }

    useAsyncEffect(async () => {
            if (accesscontrollevel.toString() === "1") {

                getAllUserDetails()
            }

        }, []
    );


    return (

        <Card extra={'w-full h-full mt-3 p-4'}>
            {accesscontrollevel.toString() === "1" ?

                loading === true ?
                    <div className="spinner">
                        <div
                            className="border-gray-300 h-10 w-10 animate-spin rounded-full border-8 border-t-[#004c86]"/>
                    </div>
                    :
                    <DpIdOverView
                        tableData={userResult}
                        columnsData={columnsDataDpIdOverview}
                    /> : <Alerts/>}
        </Card>
    );
};

export default DpConfigTable;
